/* global App */
import AbstractIceContentController from '../../abstract/ice-content/controller';

const AUTO_ANCHOR_LIST = '#auto-anchor-list';
const AUTO_ANCHOR_INDENTS = {
    H1: '0',
    H2: '1',
    H3: '2',
};
const ENABLED = 'enabled';

class Controller extends AbstractIceContentController {
    constructor(widget) {
        super(widget);
        if (document.readyState === 'interactive' || document.readyState === 'complete') {
            // Need the timeout to fix the list generation in design mode.
            setTimeout(this.init.bind(this), 0);
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        }
        this.defineHandlers();
    }

    init() {
        const listNode = this.getSelector(AUTO_ANCHOR_LIST);
        if (!listNode) {
            return null;
        }
        const autoAnchorItems = document.querySelectorAll('[id^="anchor-"]:not([no-auto-anchor])');
        const anchorsList = App.Utils.Object.nodeListToArray(autoAnchorItems);
        const fragment = document.createDocumentFragment();
        anchorsList.forEach(item => {
            if (!item) {
                return null;
            }
            const a = this.createANode(item);
            const isRichTextAnchor = App.Utils.Object.getBoolean(
                item.getAttribute('rich-text-anchor')
            );
            const indent = isRichTextAnchor
                ? this.getRichTextItemIndent(item)
                : this.getItemIndent(item);
            const li = this.createLiNode(a, indent);
            fragment.appendChild(li);
        });
        listNode.appendChild(fragment);
    }

    createANode(item) {
        const text = item.innerHTML;
        const a = document.createElement('a');
        a.appendChild(document.createTextNode(text.replace(/&nbsp;|<br>/, ' ')));
        a.addEventListener(
            'click',
            () => {
                item.scrollIntoView();
            },
            false
        );
        return a;
    }

    createLiNode(child, indent) {
        const li = document.createElement('li');
        li.setAttribute('class', `widget-auto-anchor-list__indent-${indent}`);
        li.appendChild(child);
        return li;
    }

    getItemIndent(item) {
        return item.getAttribute('indent-anchor') || '0';
    }

    getRichTextItemIndent(item) {
        const siblingTag = this.nextSiblingTag(item);
        const indent = AUTO_ANCHOR_INDENTS[siblingTag] || '0';
        item.setAttribute('indent-anchor', indent);
        return indent;
    }

    nextSiblingTag(item) {
        // Sometimes Rich Text editor wraps the anchor into <p></p>.
        // Sometimes it adds <br> to the end.
        // This method has walkaround for the issues.
        let nextSibling = item.nextElementSibling;
        if (!nextSibling || nextSibling.tagName === 'BR') {
            const parent = item.parentElement;
            nextSibling = parent && parent.nextElementSibling;
            if (!nextSibling) {
                return null;
            }
        }

        return nextSibling.tagName;
    }

    defineHandlers() {
        App.Utils.Object.nodeListToArray(
            this.getSelectors('.js_widget-auto-anchor-list__toggle')
        ).forEach(element => {
            element.addEventListener('click', this.toggleAnchorLinksGroup.bind(this));
        });
    }

    toggleAnchorLinksGroup(event) {
        // mobile devices only, rest has CSS pointer-events: none
        const parentElementClassList = event.currentTarget.parentNode.classList;
        if (parentElementClassList.contains(ENABLED)) {
            return parentElementClassList.remove(ENABLED);
        }

        parentElementClassList.add(ENABLED);
    }
}

export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-auto-anchor-list/scripts/controller.js